/**
 * Centralised React Query keys for the plugins feature.
 *
 * Mirrors the per-feature pattern used by projects/artefacts/requirements/
 * circuits — having one factory module means invalidations don't have to
 * substring-match magic strings, and the call sites can't drift apart.
 */
export const pluginKeys = {
  /** Plugin sync status for a specific project (presence + last-pushed). */
  syncStatus: (projectId: string | null | undefined) =>
    ["plugin-sync-status", projectId ?? ""] as const,
} as const;
